import React from 'react';
import {ColumnItem} from "./ColumnItem";
import { Dialog } from "@material-ui/core/";
import Grid from "@material-ui/core/Grid";
import {useTranslation} from "react-i18next";
import "./styles.css"
import close from "../../../assets/icons/close.svg"



function CustomizeView(props) {
    const {t} = useTranslation();
    const handleClose = () => {
        props.setOpen(false);

    };

    return (
        <div>
            <Dialog
                id="autom-addNew-modal"
                data-test="autom-add-new"
                open={true}
                onClose={handleClose}
                
            >
                <div className="customize-view">
                    <div className="customize-view-head">
                        <div className="customize-view-title">
                        <b>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</b>
                        </div>
                    <div className="customize-view-button-close" onClick={handleClose} >
                        <img src={close} alt="customize-view-icon" />
                        </div>
                    </div>
                    <div style={{textAlign: "left", marginTop: 20}}>
                        <Grid container spacing={2}>
                            <ColumnItem customColumn={props.customColumn} setCustomColumn={props.setCustomColumn} setOpen={props.setOpen}/>
                        </Grid>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default CustomizeView;